import { Component, inject, Inject, OnInit } from '@angular/core';
import { BsModalRef } from 'ngx-bootstrap/modal';
import { DomSanitizer, SafeResourceUrl } from '@angular/platform-browser';
import { APP_BASE_HREF, DOCUMENT } from '@angular/common';

@Component({
  selector: 'app-file-preview',
  templateUrl: './file-preview.component.html',
  styleUrls: ['./file-preview.component.scss']
})
export class FilePreviewComponent implements OnInit {
  
  appBaseUrl: any;
  constructor(
    public bsModalRef: BsModalRef,
    private sanitizer: DomSanitizer,
    @Inject(DOCUMENT) private document: Document,
    @Inject(APP_BASE_HREF) public baseHref: string,
  ) {
    this.appBaseUrl = window.location.origin +'/'+ window.location.pathname.split('/')[1];
  }

  fileName: string;
  fileUrl: any;
  fileType: string;
  safeUrl: SafeResourceUrl | null = null;

  ngOnInit(): void {
    console.log('FilePreviewComponent initialized with fileUrl:', this.fileUrl);
    this.fileType = this.determineFileType(this.fileUrl);
    if (this.fileType === 'pdf' || this.fileType === 'iframe') {
        
        console.log('Safe URL for preview:', this.appBaseUrl + '/' + this.fileUrl);
        const fullUrl = this.appBaseUrl + '/' + this.fileUrl;
      this.safeUrl = this.sanitizer.bypassSecurityTrustResourceUrl(fullUrl);
      this.fileName = this.fileUrl.split('/').pop() || 'Unknown';
    }
  }

  determineFileType(url: string): string {
    if (!url) {
      return 'unknown';
    }
    const extension = url.split('.').pop()?.toLowerCase() || '';
    if (['png', 'jpg', 'jpeg', 'gif', 'webp', 'bmp', 'svg'].includes(extension)) {
      return 'image';
    }
    if (extension === 'pdf') {
      return 'pdf';
    }
    if (['txt', 'csv'].includes(extension)) {
      return 'text';
    }
    return 'unknown';
  }

  close(): void {
    this.bsModalRef.hide();
  }

  closePreviewPopup(): void {
    this.bsModalRef.hide();
}
    downloadFile(): void {
        if (this.fileUrl) {
        const link = this.document.createElement('a');
        link.href = this.fileUrl;
        link.download = this.fileName || 'download';
        link.target = '_blank';
        link.click();
        }       
    }
}
